<template>
  <div @click="linkGame(gameInfo?.titleType)" class="my-game-card">
    <div class="title">{{ titleType(gameInfo?.titleType) }}</div>
    <div class="game-info">
      <div class="line"></div>
      <img
        class="trophy"
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/mine/trophy.png"
      />
      <div class="game-info-item">
        <p>
          <span class="num">{{ gameInfo.score }}</span
          ><span class="after-fix">分</span>
        </p>
        <p class="desc">我的最佳得分</p>
      </div>
      <div class="game-info-item">
        <p>
          <span class="before-fix">第</span><span class="num">{{ gameInfo?.rank }}</span
          ><span class="after-fix">名</span>
        </p>
        <p class="desc">当前排名</p>
      </div>
    </div>
    <p class="list-desc">
      进入<span class="list-desc-wight">排行榜前十</span>即可赢取好礼，快来刷分吧！
    </p>
    <template>
      <div class="foot">
        <div class="btn">{{gameInfo?.status === 1? '查看榜单':'去刷分' }}</div>
        <div v-if="gameInfo?.status === 1" class="status">活动已结束</div>
        <div v-if="gameInfo?.status === 0" class="countTime">
          <div class="countText">活动结束倒计时：</div>
          <div class="remaining">
            <span>{{ times.d }}</span>
            <b>天</b>
            <span>{{ times.h }}&nbsp;:</span>
            <span>{{ times.m }}&nbsp;:</span>
            <span>{{ times.s }}</span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { timerCount, replaceHyphens } from '@/utils/tools';

export default {
  components: {},
  props: {
    gameInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      endTime: null,
      times: '',
      timers: null,
      progressWidth: 0,
      currentTime: new Date().getTime(),
      // currentTime: 1700896788000,
      text: '',
    };
  },
  watch: {
    gameInfo() {
      // this.init();
      // this.renderTxt();
    },
  },
  created() {
   
  },
  mounted() {
    this.init();
  },
  methods: {
    //status  状态 0：进行中，1：已结束
    init() {
      this.endTime = new Date(replaceHyphens(this.gameInfo.endTime)).getTime();
      let temp = this.endTime - this.currentTime + 1000;
      this.times = timerCount(temp, 2);
      this.timers = setInterval(() => {
        temp -= 1000;
        if (temp > 0) {
          this.times = timerCount(temp, 2);
        } else {
          // 倒计时结束  重新拉取接口请求
          clearInterval(this.timers);
        }
      }, 1000);
    },
    titleType(type) {
      let txt = '';
      switch (type) {
        case 0:
          txt = '小游戏-研路接花花 ';
          break;
        case 1:
          txt = '小游戏-五一专场';
          break;
        case 3:
          txt = '';
          break;
        case 4:
          txt = '';
          break;
        case 5:
          txt = '';
      }

      return txt;
    },
    linkGame(type) {
      let pathName = '';
      if (type === 0) {
        pathName = 'zhuanti/gamespring';
      } else if (type === 1) {
        pathName = 'zhuanti/gamemay';
      }

      if (this.$root.$data.isApp) {
        this.$sendToApp('openNewWebView', { url: `${window.location.origin}/${pathName}` }, false);
        return;
      } else {
        window.location.href = `${window.location.origin}/${pathName}`;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.my-game-card {
  box-sizing: border-box;
  width: 100%;
  padding: 22px 36px 25px;
  background: #fff;
  border-radius: 14px;
  margin-bottom: 20px;
  .title {
    font-size: 33px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 45px;
    margin-bottom: 22px;
  }
  .game-info {
    width: 100%;
    height: 149px;
    background: #fff6ec;
    border-radius: 14px;
    display: flex;
    justify-content: space-around;
    position: relative;
    .line {
      position: absolute;
      top: 56px;
      left: 54%;
      width: 2px;
      height: 36px;
      background: #edeff3;
    }
    .trophy {
      position: absolute;
      top: 0;
      right: 0;
      width: 96px;
      height: 149px;
    }
    .game-info-item {
      width: 50%;
      height: 100%;
      text-align: center;
      padding-top: 10px;
      .desc {
        font-size: 25px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 36px;
        margin-top: 2px;
      }
      .num {
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ff7f41;
        line-height: 51px;
        display: inline-block;
      }
      .before-fix {
        font-size: 22px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 31px;
        margin-right: 9px;
      }
      .after-fix {
        font-size: 22px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 31px;
        margin-left: 9px;
      }
    }
  }
  .foot {
    width: 100%;
    position: relative;
    .btn {
      position: absolute;
      right: 0;
      top: 22px;
      height: 43px;
      background: #ff7f41;
      border-radius: 34px;
      padding: 0 29px;
      text-align: center;
      line-height: 43px;
      color: #fff;
      font-size: 25px;
    }
  }
  .list-desc {
    width: 100%;
    font-size: 25px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 36px;
    margin-top: 22px;
    .list-desc-wight {
      color: #ff7f41;
      display: inline-block;
      margin: 0 8px;
    }
  }
  .status {
    height: 36px;
    box-sizing: content-box;
    padding-top: 25px;
    margin-top: 51px;
    border-top: 1px solid #f5f5f5;
    font-size: 25px;
    color: #787878;
  }
  .countTime {
    display: flex;
    padding-top: 25px;
    margin-top: 51px;
    border-top: 1px solid #f5f5f5;

    .countText {
      color: #787878;
      font-weight: 400;
      font-size: 25px;
      line-height: 36px;
    }

    .remaining {
      display: flex;

      span {
        display: block;
        margin-left: 5px;
        color: #ff6c02;
        font-weight: 600;
        font-size: 25px;
        line-height: 36px;
      }

      b {
        display: block;
        margin-left: 5px;
        color: #787878;
        font-weight: 400;
        font-weight: normal;
        font-size: 25px;
        line-height: 36px;
      }
    }
  }
}
</style>
